module.exports = __webpack_public_path__ + "static/media/Indoor4.65efe426.jpg";